import PropTypes from 'prop-types';

/**
 * PropTypes for usage consumption calculation result
 */
export default PropTypes.shape({
    consumption: PropTypes.number.isRequired,
    nox: PropTypes.number,
    pn: PropTypes.number
});



// WEBPACK FOOTER //
// ./src/propTypes/usageConsumption.js